/**
 * Конвертирует canvas в объект File.
 * @param {HTMLCanvasElement} canvas - элемент canvas для конвертации
 * @param {string} fileName - имя создаваемого файла
 * @param {string} [mimeType='image/jpeg'] - тип MIME (по умолчанию JPEG)
 * @param {number} [quality=0.9] - качество изображения (0-1) для JPEG и WebP
 * @returns {Promise<File>} - Promise, возвращающий объект File
 */
export function convertCanvasToFile(canvas, fileName, mimeType = 'image/jpeg', quality = 0.9) {
    return new Promise((resolve, reject) => {
        canvas.toBlob(
            (blob) => {
                if (blob) {
                    const file = new File([blob], fileName, { type: mimeType });
                    resolve(file);
                } else {
                    reject(new Error('Canvas conversion to Blob failed.'));
                }
            },
            mimeType,
            quality
        );
    });
}
